export default () => {
  const handleFindRouteByQuote = async (body: { [key: string]: any }, options?: { [key: string]: any }) => {
    const api = $urlPartner.order.route.findRouteByQuote

    if (options?.modules) {
      body.modules = options.modules
    }

    const data: any = await $api(api, { body })
    const resData = data?.data?.value

    if (resData && resData.success) {
      const { routingPositions } = resData.data
      if (!routingPositions || !routingPositions?.route?.legs?.length) {
        return null
      }
      return resData.data
    }

    return null
  }

  const handleFindRouteByQuoteRequestData = async (body: { [key: string]: any }, options?: { [key: string]: any }) => {
    const api = $urlPartner.order.route.findRouteByQuoteRequestData

    if (options?.modules) {
      body.modules = options.modules
    }

    const data: any = await $api(api, { body })

    const resData = data?.data?.value

    if (resData && resData.success) {
      const { routingPositions } = resData.data

      if (!routingPositions || !routingPositions?.route?.legs?.length) {
        return null
      }
      return resData.data
    }

    return null
  }

  const handleAddRouteToPositions = (positions: { [key: string]: any }[], routingPositions: { [key: string]: any } | null | undefined) => {
    const legs = {} as { [key: string]: any }

    if (!routingPositions) {
      return positions
    }

    if (!Array.isArray(routingPositions?.route?.legs)) {
      return positions
    }

    routingPositions.route.legs.forEach((item: any) => {
      legs[`${item.startLocation}-${item.endLocation}`] = item
    })

    positions.forEach((position: { [key: string]: any }, index: number) => {
      const travelTimeToNextPosition = Object.keys(legs).length ? legs[`${position._id}-${positions?.[index + 1]?._id}`] : null

      positions[index].travelTimeToNextPosition = travelTimeToNextPosition
    })

    return positions
  }

  const handleDeleteRouteToPositions = (positions: { [key: string]: any }[]) => {
    positions.forEach((position: { [key: string]: any }, index: number) => {
      positions[index].travelTimeToNextPosition = null
    })

    return positions
  }

  return {
    handleFindRouteByQuote,
    handleFindRouteByQuoteRequestData,
    handleAddRouteToPositions,
    handleDeleteRouteToPositions
  }
}
